import type { LayoutKey } from "#build/types/layouts";

// app/middleware/device-layout.global.ts
export default defineNuxtRouteMiddleware((from, _to) => {
    // prefer server request event UA during SSR, fall back to client navigator UA
    // use import.meta.server to detect SSR environment in Nitro/Vite
    const event = import.meta.server ? useRequestEvent() : undefined;
    const serverUa = event?.node?.req?.headers?.["user-agent"] as string | undefined;
    const clientUa = typeof navigator !== "undefined" && navigator.userAgent ? navigator.userAgent : "";
    const ua = (serverUa || clientUa || "") as string;

    const device = detectDevice(ua);    

    const currentLayout = ((from?.meta?.layout as string | undefined) ?? "default").split("-");
    const layout = currentLayout[currentLayout.length - 1] as LayoutKey;

    if (device === "mobile") {
        setPageLayout(`mobile-${layout}` as unknown as LayoutKey);
    } else {
        setPageLayout(layout);
    }
});
